import { Location } from '../__types';

function getLocationById(
  location: Location[],
  id: string,
): Location | undefined {
  return location.find(loc => loc.id === id);
}

export { getLocationById };
